import { render, staticRenderFns } from "./MetadataQA.vue?vue&type=template&id=b283c5ac&scoped=true"
import script from "./MetadataQA.vue?vue&type=script&lang=js"
export * from "./MetadataQA.vue?vue&type=script&lang=js"
import style0 from "./MetadataQA.vue?vue&type=style&index=0&id=b283c5ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b283c5ac",
  null
  
)

export default component.exports